<template>
	<div class="map-part">
		<bigTitle mClass="mClass" :bigtitle="bigtitle" />
		
		<div class="flex part-1">
			<divBox1 title="各类型平均变化速度">
				<div class="flex SOC-type">
					<span
						v-for="(item, i) in batteryTypeList"
						:key="'velocityType' + i"
						:class="{at: i == batteryTypeAt}"
						@click="setBatteryTypeAt(i)">
						{{ item.label }}
					</span>
				</div>
				<myEchart
					class="myEchart"
					v-if="batteryTypeStatisticsShow"
					:id="'BatteryTypeStatistics'"
					:options="batteryTypeStatisticsOptions" />
			</divBox1>
			<divBox1 title="近10日告警趋势">
				<myEchart
					v-if="tenDaysEmergencyShow"
					:id="'TenDaysEmergency'"
					:options="tenDaysEmergencyOptions" />
			</divBox1>
		</div>
		<div class="flex part-1">
			<divBox1 title="SOC仿真平均能耗">
				<myEchart
					class="myEchart"
					v-if="cheliangTypeStatisticsShow"
					:id="'CheliangTypeStatistics'"
					:options="cheliangTypeStatisticsOptions" />
			</divBox1>
			<divBox1 title="SOC仿真平均度电里程">
				<myEchart
					class="myEchart"
					v-if="mileageStatisticsShow"
					:id="'mileageStatistics'"
					:options="mileageStatisticsOptions" />
			</divBox1>
		</div>
	</div>
</template>

<script>
import divBox1 from '../divBox1'
import bigTitle from '../bigTitle'
import myEchart from './../charts/echarts'
import { dataInterface } from '@/api/dataInterfaceApi'
import * as echarts from 'echarts5'

export default {
	components: {
		divBox1,
		myEchart,
		bigTitle
	},
	data() {
		return {
			bigtitle: {
				CHN: '安全指标',
				ENG: 'Security indicators',
			},
			dataBase: null,
			// 各类型平均变化速度
			batteryTypeStatisticsOptions: {},
			batteryTypeStatisticsShow: false,
			batteryTypeList: [
				{
					label: '各电池类型平均变化速度',
					unit: 'km/min',
					value: 'quanguo_shengshi-各电池类型平均变化速度'
				},
				{
					label: '各车辆型号平均变化速度',
					unit: 'km/min',
					value: 'quanguo_shengshi-各车辆型号平均变化速度'
				},
				{
					label: '各城市平均变化速度',
					unit: 'km/min',
					value: 'quanguo_shengshi-各城市平均变化速度'
				}
			],
			batteryTypeAt: 0,
			// SOC仿真速度统计
			cheliangTypeStatisticsOptions: {},
			cheliangTypeStatisticsShow: false,
			mileageStatisticsShow: false,
			mileageStatisticsOptions: {},
			cheliangTypeList: [
				{
					label: '仿真平均能耗',
					unit: '度/min',
					value: 'quanguo_shengshi-soc仿真平均能耗'
				},
				{
					label: '仿真平均度电里程',
					unit: 'km/度',
					value: 'quanguo_shengshi-soc仿真平均度电里程'
				},
			],
			cheliangTypeAt: 0,
			// 近10日告警趋势
			tenDaysEmergencyOptions: {},
			tenDaysEmergencyShow: false,
		}
	},
	props: {},
	watch: {},
	mounted() {},
	methods: {
		// 刷新接口需要每个子组件封装一个getData();
		getData(data) {
			console.log('sf123123123123123123123', data)
			this.dataBase = data
			// 各类型平均变化速度
			this.batteryTypeStatistics(data)
			// SOC仿真速度统计
			this.cheliangTypeStatistics(0)
			// SOC仿真速度统计
			this.cheliangTypeStatistics(1)
			// 近10日告警趋势
			this.tenDaysEmergency(data)
		},

		// 各类型平均变化速度
		setBatteryTypeAt(i) {
			this.batteryTypeAt = i
			this.batteryTypeStatistics()
		},
		// 各类型平均变化速度
		batteryTypeStatistics() {
			let data = this.dataBase || {}
			let params = {}
			let query = this.$route.query
			params = {
				'enCode': this.batteryTypeList[this.batteryTypeAt].value,//'quanguo_shengshi-各电池类型平均能耗',
				'@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
			}
			this.batteryTypeStatisticsShow = false
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return;
				// 排序
				let data = res.sort(function(a, b) { return (new Date(a.soc_month.replace('-', '/')) - new Date(b.soc_month.replace('-', '/')))})
				// let months = []
				let monthData = {}
				let batterys = []
				data.map(item => {
					if(!monthData[item.soc_month]) {
						monthData[item.soc_month] = []
					}
					monthData[item.soc_month].push(item)
					// 所有电池类型
					if(!batterys.includes(item.battery_type || item.cat_model || item.city)) {
						batterys.push(item.battery_type || item.cat_model || item.city)
					}
				})
				let xAxis = Object.keys(monthData)
				let seriesData = []
				batterys.map( battery => {
					let sData = {
						name: battery,
						type: 'line',
						showSymbol: false,
						data: []
					}
					seriesData.push(sData)
				})
				xAxis.map(item => {
					seriesData.map(sData => {
						let a = monthData[item].find( i => { return (i.battery_type || i.cat_model || i.city) == sData.name }) || {}
						sData.data.push(a.avg_change_speed || 0 )
					})
				})
				let unit = this.batteryTypeList[this.batteryTypeAt].unit
				this.batteryTypeStatisticsOptions = {
					color: ['#1968FF', '#3DDDFF', '#FFFA6D', '#77E8A9'],
					title: {
						text: unit
					},
					tooltip: {
						trigger: 'axis',
						formatter: function (params) {
							// params = params[0] || {}
							return (
								// JSON.stringify(params)
								params[0].axisValue + '<br>'
								+ params.map(item => {
									return `<div style="display: flex;justify-content: space-between;"><span>${item.marker.replace(',', '')}${item.seriesName}</span><span>${item.data}(${unit})<span></div>`
								}).join('')
							)
						},
						// axisPointer: {
						// 	type: 'cross',
						// 	label: {
						// 		backgroundColor: '#6a7985'
						// 	}
						// }
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						data: xAxis
					}],
					yAxis: [{
						type: 'value'
					}],
					series: seriesData
				}
				this.batteryTypeStatisticsShow = true
			})
			.catch((err) => {
				console.log(err)
			});
		},

		// SOC仿真速度统计
		setCheliangTypeAt(i) {
			this.cheliangTypeAt = i
			this.cheliangTypeStatistics()
		},
		// SOC仿真速度统计
		cheliangTypeStatistics(type) {
			let data = this.dataBase
			let params = {}
			let query = this.$route.query
			let typeObj = this.cheliangTypeList[type]
			params = {
				'enCode': typeObj.value,//'quanguo_shengshi-各车辆型号平均能耗',
				'@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
			}
			// 
			if(type == 0) {
				this.cheliangTypeStatisticsShow = false
			} else {
				this.mileageStatisticsShow = false
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return;
				// 排序
				let data = res.sort(function(a, b) { return (a.soc - b.soc)})
				// let months = []
				let xAxis = []
				let seriesData = {
						name: typeObj.label,
						type: 'line',
						showSymbol: false,
						data: []
					}
				data.map(item => {
					xAxis.push(item.soc)
					seriesData.data.push(item.energy_consumption || item.avg_per_kwh_mileage)
				})
				let Options = {
					color: ['#62F4CA', '#1A6AFF', '#93E59A', '#46FFF5', '#9256AD'],
					title: {
						text: typeObj.unit
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							label: {
								backgroundColor: '#6a7985'
							}
						}
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						data: xAxis
					}],
					yAxis: [{
						type: 'value'
					}],
					series: seriesData
				}
				
				if(type == 0) {
					this.cheliangTypeStatisticsOptions = Options
					this.cheliangTypeStatisticsShow = true
				} else {
					this.mileageStatisticsOptions = Options
					this.mileageStatisticsShow = true
				}
			})
			.catch((err) => {
				console.log(err)
			});
		},

		// 近10日告警趋势
		tenDaysEmergency(data = {}) {
			let params = {}
			let query = this.$route.query
			params = {
				'enCode': 'quanguo_shengshi-近10天告警趋势',
				'@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return;
				let data = res
				let xAxis = []
				let yAxis = []
				data.map(item => {
					xAxis.push(item.cur_date)
					yAxis.push(parseInt(item.alarm_cnt, 10))
				})
				this.tenDaysEmergencyOptions = {
					title: {
						text: '次'
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							label: {
								backgroundColor: '#6a7985'
							}
						}
					},
					// grid: {
					// 	left: '3%',
					// 	right: '4%',
					// 	bottom: '3%',
					// 	containLabel: true
					// },
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						data: xAxis
					}],
					yAxis: [{
						type: 'value',
						minInterval: 1,
						min: 0,
						max: 30
					}],
					series: [{
						name: '告警数量',
						type: 'line',
						stack: 'Total',
						smooth: true,
						lineStyle: {
							width: 2,
							color: '#289CFF'
						},
						showSymbol: false,
						areaStyle: {
							opacity: 0.8,
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: 'rgba(54, 161, 255, 1)'
							},
							{
								offset: 1,
								color: 'rgba(25, 104, 255, 0)'
							}])
						},
						emphasis: {
							focus: 'series'
						},
						data: yAxis
					}]
				}
				this.tenDaysEmergencyShow = true
			})
			.catch((err) => {
				console.log(err)
			});
		},

	}
}
</script>

<style lang="scss" scoped>
@import './part.scss';
</style>